/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */

import {
  homeBind,
  homeBindStatus,
  homeRenewalBind,
  motorQuotesBind, targetGateway,
  travelQuotesBind
} from '../constants/apiRequest/requestConstants/endpoints';
import { isAnalyticsEnabled } from '../constants/commonConstants';
import { CAR_INSURANCE_TYPE, HOME_INSURANCE_TYPE, TRAVEL_INSURANCE_TYPE } from '../constants/insuranceTypeConstants';
import { makeRequest } from '../helpers/makeApiRequest';

const typeNames = {
  [`${CAR_INSURANCE_TYPE}`]: 'Car',
  [`${HOME_INSURANCE_TYPE}`]: 'Home'
};

const sendAnalyticsEvent = (bindPromise, insuranceType, paymentDetails) => {
  if (isAnalyticsEnabled) {
    bindPromise.then(response => {
      if (!response.error) {
        // eslint-disable-next-line no-console
        console.log(response);
        window.dataLayer.push({
          event: 'checkout',
          transactionId: paymentDetails.payment_details.quote_reference,
          transactionAffiliation: 'Bank of Ireland',
          transactionTotal: paymentDetails.payment_details.price,
          transactionProducts: [
            {
              sku: `${typeNames[insuranceType]} Insurance`,
              name: `${typeNames[insuranceType]} Insurance GWS`,
              category: 'Consumer - Insurance',
              price: paymentDetails.payment_details.price,
              quantity: 1
            }
          ],
          catchAll: paymentDetails.payment_details.product_selected || ''
        });
      }
    });
  }
};

// eslint-disable-next-line complexity
const getBindUrl = (insuranceType, renewal) => {
  const urlMap = {
    [CAR_INSURANCE_TYPE]: `${targetGateway()}${motorQuotesBind}`,
    [TRAVEL_INSURANCE_TYPE]: `${targetGateway()}${travelQuotesBind}`,
    [HOME_INSURANCE_TYPE]: renewal ? `${targetGateway()}${homeRenewalBind}` : `${targetGateway()}${homeBind}`
  };
  return urlMap[insuranceType] ?? null;
};

export const buyNowBind = async (
  paymentDetails,
  insuranceType = 'home',
  
  props = {},
  renewal = false
) => {
  const paymentRequest = makeRequest({
    method: 'POST',
    url: getBindUrl(insuranceType, renewal),
    payload: paymentDetails,
    history: props.history
  });
  sendAnalyticsEvent(paymentRequest, insuranceType, paymentDetails);
  return await paymentRequest;
};


export const bindStatus = async (quoteReference, email, props = {}) => {
  const paymentStatus = makeRequest({
    method: 'POST',
    url: `${targetGateway()}${homeBindStatus}`,
    payload: {
      quote_reference: quoteReference,
      user_email: email
    },
    history: props.history
  });
  return await paymentStatus;
};
